module.exports = __webpack_public_path__ + "img/9788932915494.0caab635.jpg";